import { Component, Input, OnInit } from '@angular/core';
import { NewsContentPageSection } from 'src/app/model/section/news-content-page-section';

@Component({
  selector: 'app-news-content-page-accordion-section',
  templateUrl: './news-content-page-accordion-section.component.html',
  styleUrls: ['./news-content-page-accordion-section.component.scss']
})
export class NewsContentPageAccordionSectionComponent implements OnInit {
  @Input() sections: NewsContentPageSection[] = [];

  collapsedStatusArray: boolean[] = [];
  toggleMap = new Map();
  toggle = { toggle: true, accordionClass: 'not-collapsed', arrowIconsClass: 'icon-arrowUp', sectionBorderTopClass: 'border-blue', activeClass: 'active' };
  collapsed = { toggle: false, accordionClass: 'collapsed', arrowIconsClass: 'icon-arrowDown', sectionBorderTopClass: 'border-darkblack', activeClass: 'title-hover' };
  constructor() {}

  ngOnInit(): void {
    this.toggleMap.set(true, this.toggle);
    this.toggleMap.set(false, this.collapsed);
    this.toggleMap.set(undefined, this.collapsed);
  }

  toggleCollapsed(index: number) {
    this.collapsedStatusArray[index] = !this.collapsedStatusArray[index];
  }
}
